import { render, staticRenderFns } from "./BlanksDetail.vue?vue&type=template&id=cbc2c594&"
import script from "./BlanksDetail.vue?vue&type=script&lang=js&"
export * from "./BlanksDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports